import { AxiosResponse, AxiosError } from 'axios';
import { apiClient } from './apiClient';
import { apiLogger } from '../utils/loggerInstance';

// Export the centralized API client
export const api = apiClient;

// Intercept requests to handle errors
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    // Handle errors centrally here
    apiLogger.error('API error', error.response || error, {
      context: 'apiRequest',
      error: error.response || error,
    });
    return Promise.reject(error);
  },
);
